<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">Edit Shift</h5>
        <div class="edit-icons" (click)="onCancel()">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column justify-content-center">
        <h6 class="mt-3 ">This shift is part of a repeating series. How would you like to edit?</h6>
        <mat-radio-group class=" d-flex flex-column rd-box" [(ngModel)]="confirmVal">
            <div class="d-flex mt-2">
                <mat-radio-button class="" value="0"></mat-radio-button>
                <div class="radio-title l-h">Edit this shift only</div>
            </div>
            <div class="d-flex rd-l mt-2">
                <mat-radio-button class="" value="1"></mat-radio-button>
                <div class="radio-title l-h">Edit all the future shift in the series</div>
            </div>
            <div class="d-flex rd-l mt-2">
                <mat-radio-button class="" value="2"></mat-radio-button>
                <div class="radio-title l-h">All the shift in the series</div>
            </div>
        </mat-radio-group>
    </div>
    <div class="row">
        <div class="col-md-6 m-auto">
            <button mat-raised-button color="primary" class="auth-form-btn mt-3" type="submit" (click)="onSubmit()">
                {{ "BUTTON.SAVE" | translate }}</button>
        </div>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>